import styles from './notFound.module.scss';
import jlllogo from 'img/jlllogo.png';
import { Trans, useTranslation } from 'react-i18next';
import { getFullPathOrHome } from 'utils/paths';
import Link from '@mui/material/Link';

const LinkText = (props) => {
  return (
    <Link href={props.to} title={props.title || ''}>
      {props.children}
    </Link>
  );
};

export default function NotFound({ ...props } = {}) {
  const { t } = useTranslation();
  const homePath = getFullPathOrHome();
  const propsMessage =
    props && props.location && props.location.state && props.location.state.message;

  return (
    <div className={styles.container}>
      <div className={styles.column1}></div>
      <div className={styles.column2}>
        <div>
          <img className={styles.logo} alt="" src={jlllogo}></img>
          <div className={styles.title}>{t('notFoundPage.title')}</div>
          <div data-testid="NotFoundMessage" className={styles.description}>
            {propsMessage ? (
              propsMessage
            ) : (
              <Trans
                i18nKey="notFoundPage.notFoundError"
                components={<LinkText to={homePath} title="homeLink" />}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
